import axios from "axios";

// Create an Axios instance
const axiosInstance = axios.create({
  // baseURL: "https://api-staging.wihan.in/",
  // baseURL: "http://192.168.0.242:1234/",
  baseURL: "https://api.wihan.in/",
});

axiosInstance.interceptors.request.use((config) => {
  const token = localStorage.getItem("token");
  if (token) {
    config.headers["Authorization"] = `Token ${token}`;
  }
  return config;
});

export default axiosInstance;
